//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.GeneralArrangement.js";
import "../Features/Features.ShipDesign.GeneralArrangement.DrawingItemBuilder.js";
let d=[[[0,"HorizontalFrameBarPosition",1,0],[0,"ShowFireAndSafetyPlanSymbol",1,0],[0,"ShowHorizontalFrameBar",1,0],[0,"ShowOpeningFillingLine",1,0],[0,"ShowOverallDimension",1,0],[0,"ShowPMILabel",1,0],[0,"ShowVerticalFrameBar",1,0],[0,"VerticalFrameBarPosition",1,0]],[],[]];
SPLM.Features.ShipDesign.GeneralArrangement.DrawingViewItemBuilder = class extends SPLM.Features.ShipDesign.GeneralArrangement.DrawingItemBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.GeneralArrangement.DrawingViewItemBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.GeneralArrangement.DrawingViewItemBuilder.FrameBarPositionType = Object.freeze({
    "ViewTop" : "ViewTop", "ViewCenterY" : "ViewCenterY", "ViewBottom" : "ViewBottom", "ViewLeft" : "ViewLeft", "ViewCenterX" : "ViewCenterX", "ViewRight" : "ViewRight"});

export default SPLM;